import { HTMLProps, useContext } from 'react';

import {
  Collapse,
  Theme,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

import { ActivityItemContext } from './ActivityItemContext';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      paddingTop: 0,
      padding: theme.spacing(2),
    },
  });

export interface ActivityItemContentProps
  extends HTMLProps<HTMLDivElement>,
    WithStyles<typeof styles> {}

const ActivityItemContent = ({
  children,
  classes,
  className,
  ...rest
}: ActivityItemContentProps) => {
  const { open } = useContext(ActivityItemContext);
  return (
    <Collapse in={open}>
      <div className={classNames(classes.root, className)} {...rest}>
        {children}
      </div>
    </Collapse>
  );
};

export default withStyles(styles)(ActivityItemContent);
